module.exports = __webpack_public_path__ + "img/57.6.CODm.c596f681.png";